import store from "@/store";
import { USER_CRM_REQUEST } from "@/store/actions/user";
const moment = require("moment");

const boatRules = [
  {
    rule: "slot",
    handler: [(v) => !!v || "Slot number is required"],
    label: "Slot number*",
    required: true,
  },
  {
    rule: "model",
    handler: [(v) => !!v || "Model is required"],
    label: "Select boat model*",
    required: true,
  },
  {
    rule: "hin",
    handler: [(v) => !!v || "HIN is required"],
    label: "HIN*",
    required: true,
  },
  {
    rule: "sentinelSN",
    handler: [(v) => !!v || "Sentinel Serial is required"],
    label: "Sentinel SN*",
    required: true,
  },
];

const canUseCrmFeature = (feature) => {
  return !!store.getters.getMe.features[feature];
};

const getCrmFeature = (feature) => {
  return store.getters.getMe.features[feature];
};

const canUseCrmFeatureCompareString = (feature, toCompare) => {
  return store.getters.getMe.features[feature] === toCompare;
};

const isCrmGroupSuperGroup = (groupUuid) => {
  let group = store.getters.getMe.crm_groups.find((group) => {
    return group.uuid === groupUuid;
  });
  if (typeof group === "undefined") return null;

  return group.is_supergroup;
};

const canUseCrmGroupFeature = (canUsefeature, groupUuid) => {
  let group = store.getters.getMe.crm_groups.find((group) => {
    return group.uuid === groupUuid;
  });

  if (typeof group === "undefined") return false;

  let feature = group.features.find((feature) => {
    return (
      feature.name === canUsefeature && feature.value.toLowerCase() === "true"
    );
  });

  if (typeof feature === "undefined") return false;

  if (moment(feature.expire_date) < moment()) {
    return false;
  }

  return true;
};

const canUserWritePartnersPermission = (getMe, groupUuid) => {
  if (getMe.crm_groups.length === 0) {
    return false;
  }

  return getMe.crm_groups.some((group) => {
    if (group.roles.length === 0) {
      return false;
    }
    if (groupUuid !== group.uuid) {
      return false;
    }

    return group.roles.some((role) => {
      return role.dealers_permission === "WRITE";
    });
  });
};

const getBoatRules = () => {
  if (
    typeof store.getters.getMe.features.enum_required_boat_fields ===
    "undefined"
  )
    return boatRules;

  const rules =
    store.getters.getMe.features.enum_required_boat_fields.split(",");

  return boatRules.map((rule) => {
    return {
      ...rule,
      required: rules.includes(rule.rule),
      label: rules.includes(rule.rule) ? rule.label : rule.label.slice(0, -1),
      handler: rules.includes(rule.rule) ? rule.handler : [],
    };
  });
};

const canUseUserFeature = (feature) => {
  const setFeature = store.getters.getMe.user.features.find(
    (element) => element.name === feature
  );

  if (typeof setFeature === "undefined") return false;

  return setFeature.value.toLowerCase() === "true";
};

const canUserUseRefreshBoat = (group) => {
  const setGroup = store.getters.getMe.crm_groups.find(
    (element) => element.uuid === group.uuid
  );

  if (typeof setGroup === "undefined") return false;

  return setGroup.roles.some((element) => {
    return element.clear_boat_permission;
  });
};

const canUserCreateNewArticle = () => {
  if (
    typeof store.getters.getMe.menu_access.newsfeed.can_create_new !==
    "undefined"
  ) {
    return new Promise((resolve, reject) => {
      resolve(store.getters.getMe.menu_access.newsfeed.can_create_new);
    });
  }

  return new Promise((resolve, reject) => {
    store.dispatch(USER_CRM_REQUEST).then((resp) => {
      resolve(store.getters.getMe.menu_access.newsfeed.can_create_new);
    });
  });
};

const canUserSeeGroupDetails = (group) => {
  if (
    group.groups_permission === "WRITE" ||
    group.groups_permission === "READ"
  ) {
    return true;
  }
  return false;
};

const canUserAddEditGroupDetails = (group) => {
  if (group.groups_permission === "WRITE") {
    return true;
  }
  return false;
};

const nextBaseRoute = (getMe) => {
  const priorityRoutesList = [
    "dashboards",
    "boats",
    "newsfeed",
    "tasks",
    "groups",
    "data",
    "messages",
    "new-user",
  ];

  if (!store.getters.getTosAccepted) {
    return { name: "termsOfService" };
  }
  if (!store.getters.getTosPartnerAccepted) {
    return { name: "consents" };
  }

  const isLicenceStatusNeeded = store.getters.getIsLicenceStatusNeeded;
  const hasNoDealerships = getMe.dealerships.length === 0;
  const hasInternalDealer = getMe.dealerships.some(
    (dealer) => dealer.is_internal
  );

  if (isLicenceStatusNeeded && !hasNoDealerships && !hasInternalDealer) {
    if (!store.getters.getIsLicenceStatusFetched) {
      //TODO: MAKE DIFFERENT PAGE SOMETHING LIKE UNDERMAINTENANCE
      return { name: "noPermission" };
    }

    const routeBasedOnLicenceStatus =
      store.getters.getRouteBasedOnLicenceStatus;

    //NOTE: check if it is null or undefined
    if (routeBasedOnLicenceStatus == null) {
      //TODO: MAKE DIFFERENT PAGE SOMETHING LIKE UNDERMAINTENANCE
      return { name: "noPermission" };
    }

    if (Object.keys(routeBasedOnLicenceStatus).length !== 0) {
      return routeBasedOnLicenceStatus;
    }
  }

  const userVisibleTabs = Object.keys(getMe.menu_access).filter((key) => {
    return getMe.menu_access[key].visible === true;
  });

  const nextPriorityRoute = priorityRoutesList.filter((route) =>
    userVisibleTabs.includes(route)
  );
  if (nextPriorityRoute.length === 0) {
    return { name: "new-user" };
  }

  return { name: nextPriorityRoute[0] };
};

export default {
  canUseCrmFeature,
  canUseCrmFeatureCompareString,
  getCrmFeature,
  canUseCrmGroupFeature,
  getBoatRules,
  canUseUserFeature,
  canUserUseRefreshBoat,
  canUserCreateNewArticle,
  nextBaseRoute,
  canUserSeeGroupDetails,
  canUserAddEditGroupDetails,
  isCrmGroupSuperGroup,
  canUserWritePartnersPermission,
};
